import { getAuthToken } from '../util/authToken';

const API_BASE_URL = process.env.REACT_APP_HOST_URL;

export const azureFetch = async (path, requestBody) => {
    try {
        const authToken = getAuthToken();
        if (!authToken) {
            console.error("No auth token found");
            return
        }
        const response = await fetch(`${API_BASE_URL}/${path}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || response.statusText);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};